import client from './client';

const API_URL = '/api/classes';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const fetchClasses = async () => {
    try {
        const response = await client.get(API_URL, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error fetching classes:', error);
        throw error;
    }
};

export const fetchClassById = async (id) => {
    try {
        const response = await client.get(`${API_URL}/${id}`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error fetching class ${id}:`, error);
        throw error;
    }
};

export const createClass = async (classData) => {
    try {
        const response = await client.post(API_URL, classData, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error creating class:', error);
        throw error;
    }
};

export const fetchCalendarUnits = async (start, end) => {
    try {
        const response = await client.get(`${API_URL}/units/calendar`, {
            params: { start, end },
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching calendar units:', error);
        throw error;
    }
};

export const fetchStandardsCoverage = async (classId) => {
    try {
        const response = await client.get(`${API_URL}/${classId}/coverage`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error fetching standards coverage for class ${classId}:`, error);
        throw error;
    }
};

export const fetchClassLessons = async (classId) => {
    try {
        const response = await client.get(`${API_URL}/${classId}/lessons`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error fetching lessons for class ${classId}:`, error);
        throw error;
    }
};

export const deleteClass = async (id) => {
    try {
        const response = await client.delete(`${API_URL}/${id}`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error deleting class ${id}:`, error);
        throw error;
    }
};

export const fetchUnit = async (classId, unitId) => {
    try {
        const response = await client.get(`${API_URL}/${classId}/units/${unitId}`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error fetching unit ${unitId}:`, error);
        throw error;
    }
};

export const updateUnit = async (classId, unitId, data) => {
    try {
        const response = await client.put(`${API_URL}/${classId}/units/${unitId}`, data, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error updating unit ${unitId}:`, error);
        throw error;
    }
};

export const deleteUnit = async (classId, unitId) => {
    try {
        const response = await client.delete(`${API_URL}/${classId}/units/${unitId}`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error(`Error deleting unit ${unitId}:`, error);
        throw error;
    }
};

export const generateScope = async (classId, options = {}) => {
    try {
        const response = await client.post(`${API_URL}/${classId}/generate-scope`, options, { headers: getAuthHeaders() });
        return response.data.data || response.data;
    } catch (error) {
        console.error('Error generating scope:', error);
        throw error;
    }
};

export const reorderUnits = async (classId, unitOrder) => {
    try {
        const response = await client.put(`${API_URL}/${classId}/units/reorder`, { unitOrder }, { headers: getAuthHeaders() });
        return response.data.data || response.data;
    } catch (error) {
        console.error('Error reordering units:', error);
        throw error;
    }
};

export const generateUnitLessons = async (classId, unitId, templateVersionId) => {
    try {
        const response = await client.post(
            `${API_URL}/${classId}/units/${unitId}/generate-lessons`,
            { templateVersionId },
            { headers: getAuthHeaders() }
        );
        return response.data.data || response.data;
    } catch (error) {
        console.error('Error generating unit lessons:', error);
        throw error;
    }
};

export const fetchGenerationStatus = async (classId, unitId) => {
    try {
        const response = await client.get(
            `${API_URL}/${classId}/units/${unitId}/generation-status`,
            { headers: getAuthHeaders() }
        );
        return response.data.data;
    } catch (error) {
        console.error('Error fetching generation status:', error);
        throw error;
    }
};

export const cancelGeneration = async (classId, unitId) => {
    try {
        const response = await client.post(
            `${API_URL}/${classId}/units/${unitId}/generation-cancel`,
            {},
            { headers: getAuthHeaders() }
        );
        return response.data.data || response.data;
    } catch (error) {
        console.error('Error cancelling generation:', error);
        throw error;
    }
};
